/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import TableList from '~/components/tableList';
import useApi from '~/hooks/useApi';
import { useModal } from '~/hooks/useModal';
import { ListagemPendenteReprocessamento } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { useInvoiceReprocess } from '../context';
import * as St from '../styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: FormField;
}
const formInitialState = {
  cpf: { name: 'cpf', value: '' },
  numeroCartao: { name: 'numeroCartao', value: '' },
  nome: { name: 'nome', value: '' },
};
const InvoiceReprocessPendingList = () => {
  const history = useHistory();
  const [list, setList] = useState([]);

  const [form, setForm] = useState<Form>(formInitialState);

  const GetPendingList = useApi<ListagemPendenteReprocessamento[]>({
    url: Endpoints.reprocess.getPendingList,
    tryNewWay: true,
    fetchOnMount: false,
  });

  const onClearState = () => {
    GetPendingList.clear();
    setForm(formInitialState);
  };

  const { openModal, closeModal } = useModal();
  const { setSolicitationData } = useInvoiceReprocess();
  const onConsultClient = async () => {
    const response = await GetPendingList.callApi({
      cpf: form.cpf.unmasked,
      numeroCartao: form.numeroCartao?.unmasked,
      nome: form.nome,
    });
    if (response.status !== 200) {
      openModal({
        title: 'Houve um erro',
        message: response?.mensagem,
        icon: icons.exclamation,
        positiveAction: () => {
          closeModal();
          onClearState();
        },
      });
      return;
    }
    const newList = [];

    const data = response.data;
    data.forEach((data) => {
      const item = [
        // {
        //   type: 'id',
        //   value: i++,
        //   maxChar: 5,
        //   textAlign: 'center',
        // },
        {
          border: true,
          value: data?.nomeCliente,
          maxChar: 30,
          textAlign: 'center',
        },
        {
          value: data.dataSolicitacao
            ? moment(data.dataSolicitacao).format('DD/MM/YYYY HH:mm')
            : '',
          maxChar: 20,
          textAlign: 'center',
        },
        {
          border: true,
          value: data?.usuarioSolicitante,
          maxChar: 35,
          textAlign: 'center',
        },
        {
          border: true,
          value: data.numeroProtocoloInterno,
          maxChar: 25,
          textAlign: 'center',
        },

        {
          item: data,
          searchAction: () => goToDetail(data),
        },
      ];
      newList.push(item);
    });

    setList(newList);
  };
  const customerHeader = [
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 30,
      textAlign: 'left',
    },
    {
      id: 2,
      value: 'Data solicitação',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Usuário solititação',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Nr do chamado',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  const goToDetail = async (item: any) => {
    history.push('/invoice/reprocess/pending/details', item);
  };

  return (
    <>
      <Loading status={GetPendingList.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                name={form.cpf.name}
                value={form.cpf.value}
                onChange={(e) => setFormState(e, form, setForm)}
                placeholder="000.000.000-00"
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.numeroCartao.name}
                value={form.numeroCartao.value}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Nome"
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.nome.name}
                value={form.nome.value}
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <Button
                fitContent
                onClick={onConsultClient}
                loading={GetPendingList.loading}
                disabled={
                  (form.cpf.value.length !== 14 &&
                    form.numeroCartao.value.length !== 19 &&
                    !form.nome) ||
                  GetPendingList.loading
                }
              >
                <span>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {GetPendingList.isFetched ? (
          <St.BoxCard>
            {GetPendingList.data?.length > 0 ? (
              <TableList customerHeader={customerHeader} list={list} />
            ) : (
              <span>Nenhum resultado encontrado</span>
            )}
          </St.BoxCard>
        ) : null}
      </Container>
    </>
  );
};

export default InvoiceReprocessPendingList;
